import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Switch,
  Tab,
  TablePagination,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import { useSelector } from "react-redux";
import { ShopifyProductFilter } from "../../../../models/app/AppModels";
import {
  useGetShopifyProductsMutation,
  useSyncShopifyToAggregateWithDMSMutation,
  useGetDmsWholegoodsMutation,
  useGetAggProductsByShopIdMutation,
  useUnsynAggregateProductMutation,
  useGetDmsWholegoodsV2Mutation,
} from "../../../../redux/reducer/features/Integration/DmsSetupSlice";
import { AppState } from "../../../../redux/reducer/rootReducer";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircleOutline";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ProductType } from "../../../../models/features/Integration/DmsSetup";
import PageLoader from "../../../app/PageLoader";
import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchIcon from "@mui/icons-material/Search";
import { useGetDmsPartsMutation } from "../../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { DmsPartRequestDto } from "../../../../models/features/ShoppingPortal/DmsPart";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "2px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
interface ShopifyProductGridProps {
  ShopifyProductStatus: string;
}

const ShopifyProductGrid: React.FunctionComponent<ShopifyProductGridProps> = (
  props
) => {
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const productTypes = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.productTypes
  );
  const [shopifyProducts, setShopifyProducts] = React.useState<any[]>([]);
  const [aggregateProducts, setAggregateProducts] = React.useState<any[]>([]);
  const [productType, setProductType] = React.useState(0);
  const [products, setProducts] = React.useState<any[]>([]);
  const [parts, setParts] = React.useState<any[]>([]);
  const [ShopifyProductsCount, setShopifyProductsCount] =
    React.useState<number>(0);
  const [dmsPopup, setDmsPopup] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [searchShopifyProduct, setSearchShopifyProduct] = React.useState("");
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  const [isUsedProduct, setIsUsedProduct] = React.useState(false);
  const [value, setValue] = React.useState("Wholegoods");
  const [selectedVariantId, setSelectedVariantId] = React.useState(0);
  const [openAggregateProducts, setOpenAggregateProducts] =
    React.useState(false);
  const [selectedRowData, setSelectedRowData] = React.useState<any>();

  const [shopifyProductsMutation, shopifyProductsMutationResult] =
    useGetShopifyProductsMutation();
  const [unsynAggregateMutation, unsynAggregateMutationResult] =
    useUnsynAggregateProductMutation();
  const [getAggregateProductsMutation, getAggregateProductsMutationResult] =
    useGetAggProductsByShopIdMutation();
  const [addShopifyToAggregate, addShopifyToAggregateMutationResult] =
    useSyncShopifyToAggregateWithDMSMutation();
  const [dmsWhoolgoodsMutation, dmsWhoolgoodsMutationResult] =
    useGetDmsWholegoodsV2Mutation();
  const [getDmsPartsMutation, getDmsPartsMutationResult] =
    useGetDmsPartsMutation();
  const [usedProductsMutation, usedProductsMutationResult] =
    useGetDmsWholegoodsMutation();
  const [pageInfo, setPageInfo] = React.useState<{
    endCursor?: string;
    hasNextPage?: string;
    hasPreviousPage?: string;
    startCursor?: string;
    pageIndex: number;
    shopifyProductStatus?: string;
  }>({ pageIndex: 0 });

  const [shopifyPaging, setShopifyPaging] =
    React.useState<ShopifyProductFilter>({
      pageIndex: 0,
      pageSize: 10,
      totalRecords: 0,
      quickFilterValues: [],
      items: [],
    });

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    if (newValue === "Wholegoods") {
      setProductType(0);
    } else {
      setProductType(1);
    }
  };
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setShopifyPaging({
      ...shopifyPaging,
      pageIndex: newPage,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setShopifyPaging({
      ...shopifyPaging,
      pageSize: parseInt(event.target.value, 10),
      pageIndex: 0,
    });
  };

  React.useEffect(() => {
    var requestPaging = { ...shopifyPaging };
    if (shopifyPaging.pageIndex > pageInfo?.pageIndex) {
      requestPaging = {
        ...shopifyPaging,
        endCursor: pageInfo.endCursor,
        startCursor: undefined,
      };
    } else if (
      shopifyPaging.pageIndex < pageInfo?.pageIndex &&
      shopifyPaging.pageIndex !== 0
    ) {
      requestPaging = {
        ...shopifyPaging,
        endCursor: undefined,
        startCursor: pageInfo.startCursor,
      };
    } else {
      requestPaging = {
        ...shopifyPaging,
        endCursor: undefined,
        startCursor: undefined,
      };
    }
    shopifyProductsMutation({
      setupId: dmsSetup?.id ?? "",
      paging: {
        ...requestPaging,
        shopifyProductStatus:
          props.ShopifyProductStatus === "all"
            ? undefined
            : props.ShopifyProductStatus,
      },
    });
  }, [shopifyPaging, props.ShopifyProductStatus]);

  const handleClose = () => {
    setDmsPopup(false);
    setOpenAggregateProducts(false);
  };
  const handleSearch = () => {
    fetchWholegoodData();
    if (productTypes?.some((n) => n === "Parts")) {
      fetchPartsData();
    }
  };
  const fetchWholegoodData = () => {
    setIsFirstLoad(false);
    if (isUsedProduct) {
      usedProductsMutation({
        data: {
          dealerIds:
            dmsSetup?.dmsLocations.map((n) => n.dealerId.toString()) ?? [],
          search: search,
          searchModels: [],
          stockingOnly: true,
          wildCardSearch: true,
          requestType: "UsedProduct",
        },
      }).then((res: any) => {
        if (res && res?.data) {
          let data = res.data.entityList.map((item: any, index: number) => ({
            ...item,
            id: index,
          }));
          setProducts(data);
        }
      });
    } else {
      dmsWhoolgoodsMutation({
        data: {
          dealerIds:
            dmsSetup?.dmsLocations.map((n) => n.dealerId.toString()) ?? [],
          search: search,
          searchModels: [],
          stockingOnly: false,
          wildCardSearch: true,
        },
      }).then((res: any) => {
        if (res && res?.data) {
          let data = res.data.entityList.map((item: any, index: number) => ({
            ...item,
            id: index,
          }));
          setProducts(data);
        }
      });
    }
  };

  const fetchPartsData = () => {
    setIsFirstLoad(false);
    var data: DmsPartRequestDto = {
      dealerIds: dmsSetup?.dmsLocations.map((n) => n.dealerId.toString()) ?? [],
      pageSize: 1000,
      pageNumber: 0,
      stockingOnly: false,
      searchPartNumber: "",
      searchPartDescription: "",
      search: search,
      searchManufacturerId: "",
      searchManufacturerCode: [],
      searchManufacturerCodeNotIn: [],
      inventoryPartIdNotIn: [],
    };
    getDmsPartsMutation({ data: data }).then((res: any) => {
      if (res && res?.data) {
        let data = res.data.entityList.map((item: any, index: number) => ({
          ...item,
          id: index,
        }));
        setParts(data);
      }
    });
  };

  const handleClick = (item: any) => {
    setSelectedRowData(item);
  };
  const handleOpenSyncedProducts = (item: any, variantId: string) => {
    setOpenAggregateProducts(true);
    setSelectedRowData(item);
    getAggregateProductsMutation({
      shopifyProductId: item.id,
      variantId: variantId,
    }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          setAggregateProducts(res.data.entityList);
        }
      }
    });
  };

  const handleUnsynAggregateProduct = (aggregateId: string) => {
    unsynAggregateMutation({ productId: aggregateId }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          setOpenAggregateProducts(false);
          shopifyProductsMutation({
            setupId: dmsSetup?.id ?? "",
            paging: {
              ...shopifyPaging,
              shopifyProductStatus:
                props.ShopifyProductStatus === "all"
                  ? undefined
                  : props.ShopifyProductStatus,
            },
          });
        }
      }
    });
  };

  const onSyncProductAction = (product: any) => {
    addShopifyToAggregate({
      Wholegood: productType === 0 ? product : null,
      Part: productType === 1 ? product : null,
      productType:
        productType === 0 ? ProductType.Whoolgoods : ProductType.Parts,
      Handle: selectedRowData.handle,
      shopifyProductId: selectedRowData.id,
      shopifyProductVariantId: selectedVariantId,
      isUsedProduct: isUsedProduct,
    });
  };

  React.useEffect(() => {
    if (shopifyProductsMutationResult.data) {
      let products = shopifyProductsMutationResult.data.entity.productDto.map(
        (item: any) => ({ ...item, open: false })
      );
      setShopifyProducts(products);
      setShopifyProductsCount(shopifyProductsMutationResult.data.totalRecords);
      setPageInfo({
        ...shopifyProductsMutationResult.data.entity.pageInfo,
        pageIndex: shopifyPaging.pageIndex,
      });
    }
  }, [shopifyProductsMutationResult]);

  React.useEffect(() => {
    if (addShopifyToAggregateMutationResult.data) {
      setDmsPopup(false);
      setShopifyProducts(
        shopifyProducts.map((item: any) =>
          item.id ==
          addShopifyToAggregateMutationResult.data.entity.shopifyProductId
            ? {
                ...item,
                variants: item.variants.map((variant: any) =>
                  variant.id ==
                  addShopifyToAggregateMutationResult.data.entity.variantId
                    ? {
                        ...variant,
                        isSynced: true,
                        price:
                          addShopifyToAggregateMutationResult.data.entity.price,
                      }
                    : variant
                ),
              }
            : item
        )
      );
    }
  }, [addShopifyToAggregateMutationResult]);

  const debounce = (func: Function, delay: number) => {
    let timer: ReturnType<typeof setTimeout>;
    return function (this: any, ...args: any[]) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const handleSearchTextChange = React.useCallback(
    debounce((value: any) => {
      setShopifyPaging({
        ...shopifyPaging,
        quickFilterValues: [value],
        pageIndex: 0,
      });
    }, 1000),
    []
  );
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchShopifyProduct(value);
    handleSearchTextChange(value);
  };

  function Row(props: any) {
    const { row } = props;
    const handleRowOpen = (id: any) => {
      setShopifyProducts(
        shopifyProducts.map((item: any) =>
          item.id === id && item.open === false
            ? { ...item, open: true }
            : { ...item, open: false }
        )
      );
    };

    return (
      <React.Fragment>
        <TableRow
          sx={{ cursor: "pointer" }}
          onClick={() => handleRowOpen(row.id)}
        >
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              sx={{ padding: 0 }}
            >
              {row.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell sx={{ padding: "10px" }}>{row.title}</TableCell>
          <TableCell sx={{ padding: "10px" }} align="left">
            {row.variants[0].sku}
          </TableCell>
          <TableCell align="center" sx={{ padding: "10px" }}>
            {getSyncedCountChip(row?.variants)}
          </TableCell>
          <TableCell align="center" sx={{ padding: "10px" }}>
            {getStatusChip(row.status)}
          </TableCell>
        </TableRow>
        <TableRow sx={{ backgroundColor: "#f9f9f9" }}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
            <Collapse in={row.open} timeout="auto" unmountOnExit>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", marginBottom: 0 }}
                  gutterBottom
                  component="div"
                >
                  Variants
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ paddingLeft: 0, width: "45%" }}>
                        Title
                      </TableCell>
                      <TableCell sx={{ paddingLeft: 0, width: "15%" }}>
                        <span style={{ color: "#E0E0E0" }}>|</span> SKU
                      </TableCell>
                      <TableCell align="right" sx={{ width: "10%" }}>
                        <span style={{ color: "#E0E0E0" }}>|</span> Price($)
                      </TableCell>
                      <TableCell align="center">
                        <span style={{ color: "#E0E0E0" }}>|</span> Status
                      </TableCell>
                      <TableCell align="center">
                        <span style={{ color: "#E0E0E0" }}>|</span>Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.variants.map((variant: any) => (
                      <TableRow
                        key={variant?.id}
                        sx={{ "& > *": { borderBottom: "unset" } }}
                      >
                        <TableCell
                          scope="row"
                          align="left"
                          sx={{ paddingLeft: 0 }}
                        >
                          {variant.title}
                        </TableCell>
                        <TableCell sx={{ paddingLeft: 0 }}>
                          {variant.sku}
                        </TableCell>
                        <TableCell align="right">
                          {variant.price.toFixed(2)}
                        </TableCell>
                        <TableCell align="center">
                          {getProductStatusChip(variant?.isSynced)}
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            disabled={!variant.isSynced}
                            color="success"
                            variant="contained"
                            sx={{ fontSize: "0.6rem", marginRight: "5px" }}
                            size="small"
                            onClick={() => {
                              handleOpenSyncedProducts(row, variant.id);
                              setSelectedVariantId(variant.id);
                            }}
                          >
                            View
                          </Button>
                          |
                          <Button
                            disabled={variant.isSynced}
                            color="warning"
                            variant="contained"
                            size="small"
                            sx={{ fontSize: "0.6rem", marginLeft: "5px" }}
                            onClick={() => {
                              handleClick(row);
                              setDmsPopup(true);
                              setSelectedVariantId(variant.id);
                            }}
                          >
                            Sync
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  const columns: GridColDef[] = [
    {
      field: "mfgName",
      headerName: "DMS Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.mfrCode + " - " + params.row.mfgName,
    },
    {
      field: "model",
      headerName: "Model",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) => params.row.model,
    },
    {
      field: "price",
      headerName: "Price ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "stockItem",
      headerName: "Stocking Type",
      headerAlign: "center",
      flex: 1,
      align: "center",
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.stockItem ? (
          <Chip label="Stocking" color="success" size="small" />
        ) : (
          <Chip label="Non Stocking" color="warning" size="small" />
        );
      },
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.locationCount) {
          return params.row?.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0
          );
        }
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <IconButton
            id="basic-button"
            onClick={(n) => {
              onSyncProductAction(params.row);
            }}
          >
            <AddCircleIcon />
          </IconButton>
        );
      },
    },
  ];

  const partsColumns: GridColDef[] = [
    {
      field: "mfgName",
      headerName: "DMS Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.mfrCode + " - " + params.row.mfrName,
    },
    {
      field: "partNumber",
      headerName: "Part Number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.partNumber,
    },
    {
      field: "price",
      headerName: "Price ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "suggestedRetailPrice",
      headerName: "Retail Price ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.suggestedRetailPrice.toFixed(2),
    },

    {
      field: "averageCost",
      headerName: "Cost ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.averageCost.toFixed(2),
    },
    {
      field: "stockItem",
      headerName: "Stocking Type",
      headerAlign: "center",
      flex: 1,
      align: "center",
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.stockItem ? (
          <Chip label="Stocking" color="success" size="small" />
        ) : (
          <Chip label="Non Stocking" color="warning" size="small" />
        );
      },
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.locationCount) {
          return params.row?.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0
          );
        }
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <IconButton
            id="basic-button"
            onClick={(n) => {
              onSyncProductAction(params.row);
            }}
          >
            <AddCircleIcon />
          </IconButton>
        );
      },
    },
  ];

  return (
    <>
      <PageLoader
        isLoading={addShopifyToAggregateMutationResult.isLoading}
      ></PageLoader>
      <Card>
        <Box textAlign="right">
          <TextField
            id="search"
            name="search"
            placeholder="Search.."
            variant="standard"
            size="small"
            onChange={handleChange}
            value={searchShopifyProduct}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "20px" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ height: "65vh" }}>
          <Table
            aria-label="collapsible table"
            sx={{ borderCollapse: "separate" }}
          >
            <TableHead
              sx={{
                position: "sticky",
                zIndex: 1,
                top: 0,
                background: "white",
              }}
            >
              <TableRow sx={{ height: "2vh" }}>
                <TableCell sx={{ width: "5%" }} />
                <TableCell
                  sx={{ paddingLeft: 0, width: "40%", padding: "10px" }}
                >
                  Title
                </TableCell>
                <TableCell align="left" sx={{ padding: 0, width: "20%" }}>
                  {" "}
                  <span style={{ color: "#E0E0E0" }}>|</span> SKU
                </TableCell>
                <TableCell align="center" sx={{ padding: 0 }}>
                  {" "}
                  <span style={{ color: "#E0E0E0" }}>|</span> Synced Count
                </TableCell>
                <TableCell align="center" sx={{ padding: 0 }}>
                  {" "}
                  <span style={{ color: "#E0E0E0" }}>|</span> Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shopifyProductsMutationResult.isLoading ? (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Box
                      justifyContent="center"
                      alignItems="center"
                      display="flex"
                      sx={{ height: "60vh" }}
                    >
                      <CircularProgress size="2.2rem" color="inherit" />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : shopifyProducts && shopifyProducts.length > 0 ? (
                shopifyProducts.map((row) => <Row key={row.id} row={row} />)
              ) : (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Box
                      justifyContent="center"
                      alignItems="center"
                      display="flex"
                      sx={{ height: "60vh" }}
                    >
                      <Typography>No Rows to Show</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 20, 50]}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
          count={ShopifyProductsCount}
          rowsPerPage={shopifyPaging.pageSize}
          page={shopifyPaging.pageIndex}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <Dialog open={dmsPopup} onClose={handleClose} maxWidth={"lg"} fullWidth>
        <DialogTitle alignSelf={"center"}>DMS Products/Parts</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Grid container>
            <Grid item xs={6}>
              <TextField
                id="search"
                name="search"
                label="Wholegood/Part"
                variant="standard"
                onChange={(event) => {
                  setSearch(event.target.value);
                }}
                value={search}
              />
            </Grid>
            <Grid item style={{ textAlign: "right" }} xs={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={isUsedProduct}
                    name="isUsedProduct"
                    color="warning"
                    onChange={(e) => {
                      setIsUsedProduct(e.target.checked);
                      setProducts([]);
                      setParts([]);
                      setIsFirstLoad(true);
                    }}
                  />
                }
                label="Used Product Only"
              />
              <Button
                variant="contained"
                disabled={
                  search.length < 3 ||
                  getDmsPartsMutationResult.isLoading ||
                  dmsWhoolgoodsMutationResult.isLoading
                }
                onClick={handleSearch}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          <Card sx={{ p: 0 }}>
            <CardContent sx={{ minHeight: 500, p: 0 }}>
              {isFirstLoad ? (
                ""
              ) : (
                <TabContext value={value.toString()}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList onChange={handleTabChange}>
                      {productTypes?.some((n) => n === "Wholegoods") && (
                        <Tab label={"Wholegoods"} value={"Wholegoods"} />
                      )}
                      {productTypes?.some((n) => n === "Parts") &&
                        !isUsedProduct && (
                          <Tab label={"Parts"} value={"Parts"} />
                        )}
                    </TabList>
                  </Box>

                  {
                    <TabPanel value="Wholegoods" style={{ padding: 0 }}>
                      <Box sx={{ height: 480, width: "100%" }}>
                        <DataGrid
                          rows={products}
                          columns={columns}
                          loading={
                            dmsWhoolgoodsMutationResult.isLoading ||
                            usedProductsMutationResult.isLoading
                          }
                          components={{}}
                        ></DataGrid>
                      </Box>
                    </TabPanel>
                  }

                  <TabPanel value="Parts" style={{ padding: 0 }}>
                    <Box sx={{ height: 480, width: "100%" }}>
                      <DataGrid
                        rows={parts}
                        columns={partsColumns}
                        loading={getDmsPartsMutationResult.isLoading}
                        components={{}}
                      ></DataGrid>
                    </Box>
                  </TabPanel>
                </TabContext>
              )}
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth="md"
        fullWidth
        open={openAggregateProducts}
        onClose={handleClose}
        PaperProps={{
          style: { height: "50vh" },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "2px",
            paddingBottom: "2px",
          }}
        >
          <Typography color="primary" sx={{ fontWeight: "bold" }}>
            Aggregate Products
          </Typography>
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Table aria-label="customized table">
            <TableBody>
              <StyledTableRow
                sx={{
                  height: "40px",
                  backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                }}
              >
                <StyledTableCell sx={{ color: "primary", fontWeight: "bold" }}>
                  Title
                </StyledTableCell>
                <StyledTableCell sx={{ color: "primary", fontWeight: "bold" }}>
                  Model / Part
                </StyledTableCell>
                <StyledTableCell
                  sx={{ color: "primary", fontWeight: "bold" }}
                  align="right"
                >
                  Price($)
                </StyledTableCell>
                <StyledTableCell
                  sx={{ color: "primary", fontWeight: "bold" }}
                  align="center"
                >
                  Type
                </StyledTableCell>
                <StyledTableCell
                  sx={{ color: "primary", fontWeight: "bold" }}
                  align="center"
                >
                  Action
                </StyledTableCell>
              </StyledTableRow>
              {getAggregateProductsMutationResult.isLoading ? (
                <StyledTableRow>
                  <StyledTableCell align="center" colSpan={5}>
                    Loading Products...
                  </StyledTableCell>
                </StyledTableRow>
              ) : aggregateProducts && aggregateProducts.length > 0 ? (
                aggregateProducts.map((prod: any, index: number) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell>{prod?.title}</StyledTableCell>
                    <StyledTableCell>
                      {prod.type === "Parts"
                        ? prod?.partNumber
                        : prod.modelNumber}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {prod?.price?.toFixed(2) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {getProductTypeChip(prod?.type ?? "")}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Button
                        onClick={() => {
                          handleUnsynAggregateProduct(prod.id);
                        }}
                        disabled={unsynAggregateMutationResult.isLoading}
                        variant="contained"
                        size="small"
                        sx={{ fontSize: "0.6rem" }}
                        color="error"
                      >
                        {unsynAggregateMutationResult.isLoading ? (
                          <CircularProgress size="1.2rem" color="inherit" />
                        ) : (
                          "Delete"
                        )}
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <StyledTableRow>
                  <StyledTableCell align="center" colSpan={5}>
                    No Serial Found.
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
    </>
  );
};

const getStatusChip = (status: string) => {
  if (status.toLowerCase() === "active")
    return <Chip label="Active" color="success" size="small" />;
  else return <Chip label="Draft" color="error" size="small" />;
};

const getProductStatusChip = (status: boolean) => {
  if (status === true)
    return <Chip label="Synced" color="success" size="small" />;
  else return <Chip label="Not Synced" color="error" size="small" />;
};
const getProductTypeChip = (type: string) => {
  if (type === "Wholegoods") {
    return <Chip label="Wholegood" color="success" size="small" />;
  } else if (type === "Parts") {
    return <Chip label="Part" color="warning" size="small" />;
  } else if (type === "NewArrival") {
    return <Chip label="Virtual Showroom" color="primary" size="small" />;
  } else if (type === "UsedProduct") {
    return <Chip label="Used Product" color="info" size="small" />;
  } else return <Chip label={type} color="error" size="small" />;
};
const getSyncedCountChip = (variants: any) => {
  let totalVariants = variants?.length;

  let syncedVariants = variants.filter((v: any) => v.isSynced === true).length;

  if (syncedVariants === totalVariants) {
    return (
      <Chip
        label={syncedVariants + "/" + totalVariants}
        color="success"
        size="small"
      />
    );
  } else if (syncedVariants < totalVariants && syncedVariants > 0) {
    return (
      <Chip
        label={syncedVariants + "/" + totalVariants}
        color="warning"
        size="small"
      />
    );
  } else {
    return (
      <Chip
        label={syncedVariants + "/" + totalVariants}
        color="error"
        size="small"
      />
    );
  }
};
export default ShopifyProductGrid;
